import React, { useState } from 'react';
import cx from 'classnames';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import CardLayout from '@magoosh/layouts/card';
import { FontAwesomeIcon } from '@magoosh/lib/icons';
import { paths } from 'config/path_helpers';

import ContextualLink from '@test_prep/app/components/contextual_link';
import { useQueries } from '@test_prep/app/queries';

import ScoreReportPart from '../components/score_report_part';

import colors from '@magoosh/lib/styles/colors.module.scss';
import style from './style.module.scss';

export default (props) => {
  const { id, answerId } = useParams();
  const q = useQueries();
  const [volume, setVolume] = useState(1);

  const pagePath = paths.scoreReportAnswer(id, answerId);
  const pageQuery = q.pageQuery(pagePath);
  const page = pageQuery.data;

  const scoreReportPart = (page?.scoreReport?.content?.parts || []).find(
    (part) => part.answerId === page.answer.id
  );

  return (
    <div className="bg-gray-lightest d-flex flex-column gap-m">
      <Helmet>
        <title>
          {
            page?.scoreReport?.reportType ? (
              `${page.scoreReport.reportType} Score Report - Response Details`
            ) : 'Score Report - Response Details'
          }
        </title>
      </Helmet>

      <div className={style.navigationBar}>
        <div className="align-items-sm-center container d-flex flex-column flex-sm-row gap-xs gap-sm-s">
          <div className={cx(style.navigation, 'align-items-center d-flex flex-1 gap-xs gap-sm-s')}>
            <FontAwesomeIcon icon="chevron-left" />

            <ContextualLink href={paths.scoreReport(id)} style={{ color: colors.textColor }}>
              Full Score Report
            </ContextualLink>
          </div>

          <div className="d-flex justify-content-sm-center">
            <h4 className="u-margin-A-n">
              <strong>Response Details</strong>
            </h4>
          </div>

          <div className="flex-1 hidden-xs" />
        </div>
      </div>

      <CardLayout loading={!page}>
        {({ loading }) => {
          if (loading) return;

          return (
            <CardLayout.Card className="d-flex flex-column gap-m">
              <h3 className="u-margin-A-n">
                <strong>Your response</strong>
              </h3>

              <div className="u-border-A-s u-padding-A-s" style={{ borderRadius: 8 }}>
                <ScoreReportPart
                  analysisDefaultExpanded
                  answer={page.answer}
                  reportType={page.scoreReport.reportType}
                  scoreReportPart={scoreReportPart}
                  volume={volume}
                  setVolume={setVolume}
                />
              </div>
            </CardLayout.Card>
          );
        }}
      </CardLayout>
    </div>
  );
};
